<div class="d-flex align-items-center justify-content-between mb-3">
  <h5 class="m-0">Live ჩანაწერები</h5>
  <div class="text-muted small">სულ: {{ total }}</div>
</div>

<div class="card p-3 mb-3">
  <h5 class="mb-3">Live title</h5>

  <div class="mb-3">
    <label class="form-label">სათაური ქართულად</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="liveMetaForm.title_ka"
    />
  </div>

  <div class="mb-3">
    <label class="form-label">Title in English</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="liveMetaForm.title_en"
    />
  </div>

  <button class="btn btn-primary" type="button" (click)="saveLiveMeta()">
    შენახვა
  </button>
</div>

<ng-template #noLiveBlock>
  <div class="alert alert-light border mb-3">
    ლაივი ამჟამად ჩართული არ არის
  </div>
</ng-template>

<div class="card">
  <div class="table-responsive">
    <table class="table table-hover align-middle mb-0">
      <thead>
        <tr>
          <th style="width: 80px">ID</th>
          <th>Stream</th>
          <th>Status</th>
          <th class="text-nowrap">MP4 Size</th>
          <th class="text-nowrap">Created</th>
          <th class="text-end" style="width: 260px">ქმედება</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of items">
          <td>#{{ item.id }}</td>

          <td>
            <div class="fw-semibold">{{ item.stream_key }}</div>
            <div class="small text-muted">{{ $any(item).title || '-' }}</div>
          </td>

          <td>
            <span [class]="statusBadgeClass(item.status)">{{ item.status }}</span>
          </td>

          <td class="text-nowrap">
            {{ bytesToMb(item.mp4_size_bytes || 0) }}
          </td>

          <td class="text-nowrap">
            <span class="small">{{ item.created_at | date:'yyyy-MM-dd HH:mm' }}</span>
          </td>

          <td class="text-end">
            <div class="d-flex flex-column align-items-end gap-2">
              <div class="d-flex justify-content-end flex-wrap gap-2">
                <button
                  class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
                  type="button"
                  (click)="openTitleEditor(item)">
                  <i class="fi fi-rr-edit"></i>
                  <span class="d-none d-md-inline">სახელი</span>
                </button>

                <button
                  class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                  [disabled]="item.status !== 'ready' || !mp4Url(item)"
                  (click)="openPlayer(item)">
                  <i class="fi fi-rr-play"></i>
                  <span class="d-none d-md-inline">ნახვა</span>
                </button>

                <a
                  class="btn btn-sm btn-outline-success d-flex align-items-center gap-1"
                  *ngIf="item.status === 'ready' && mp4Url(item)"
                  [href]="mp4Url(item)!"
                  target="_blank">
                  <i class="fi fi-rr-download"></i>
                  <span class="d-none d-md-inline">ჩამოტვირთვა</span>
                </a>

                <button
                  class="btn btn-sm btn-outline-dark d-flex align-items-center gap-1"
                  type="button"
                  *ngIf="item.status === 'ready' && mp4Url(item)"
                  (click)="toggleTrim(item)">
                  <i class="fi fi-rr-scissors"></i>
                  <span class="d-none d-md-inline">ამოჭრა</span>
                </button>

                <button
                  class="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
                  type="button"
                  (click)="deleteRecording(item)">
                  <i class="fi fi-rr-trash"></i>
                  <span class="d-none d-md-inline">წაშლა</span>
                </button>
              </div>
            </div>
          </td>
        </tr>

        <tr *ngIf="!loading && (!items || !items.length)">
          <td colspan="6" class="text-center text-muted py-4">
            ჩანაწერები ვერ მოიძებნა
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="card-footer d-flex align-items-center justify-content-between">
    <div class="small text-muted">Page {{ page }} / {{ lastPage }}</div>
    <div class="btn-group">
      <button class="btn btn-sm btn-outline-secondary" [disabled]="page <= 1 || loading" (click)="fetch(page - 1)">წინა</button>
      <button class="btn btn-sm btn-outline-secondary" [disabled]="page >= lastPage || loading" (click)="fetch(page + 1)">შემდეგი</button>
    </div>
  </div>
</div>

<div class="player-backdrop" *ngIf="selected" (click)="closePlayer()"></div>
<div class="player-modal" *ngIf="selected">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div class="fw-semibold">ვიდეოს ამოღება</div>
    <button class="btn btn-sm btn-outline-light" (click)="closePlayer()">X</button>
  </div>

  <video
    *ngIf="mp4Url(selected)"
    [src]="mp4Url(selected)!"
    controls
    autoplay
    playsinline
    style="width: 100%; max-height: 70vh; background: #000; border-radius: 12px;">
  </video>

  <div *ngIf="!mp4Url(selected)" class="text-warning small">
    MP4 URL ვერ მოიძებნა.
  </div>
</div>

<div class="player-backdrop" *ngIf="selectedTrimItem" (click)="selectedTrimItem = undefined"></div>
<div class="player-modal" *ngIf="selectedTrimItem" (click)="$event.stopPropagation()">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div class="fw-semibold">ვიდეოს ამოჭრა</div>
    <button class="btn btn-sm btn-outline-light" (click)="selectedTrimItem = undefined">X</button>
  </div>

  <app-recording-trim
    [filename]="getFilename(selectedTrimItem)"
    [videoUrl]="mp4Url(selectedTrimItem)">
  </app-recording-trim>
</div>









<div class="player-backdrop" *ngIf="selectedTrimItem" (click)="selectedTrimItem = undefined"></div>
<div class="player-modal" *ngIf="selectedTrimItem" (click)="$event.stopPropagation()">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div class="fw-semibold">ვიდეოს ამოჭრა</div>
    <button class="btn btn-sm btn-outline-light" (click)="selectedTrimItem = undefined">X</button>
  </div>

  <app-recording-trim
    [filename]="getFilename(selectedTrimItem)"
    [videoUrl]="mp4Url(selectedTrimItem)">
  </app-recording-trim>
</div>
<div class="player-backdrop" *ngIf="selectedTitleItem" (click)="selectedTitleItem = null"></div>
<div class="player-modal" *ngIf="selectedTitleItem">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <div class="fw-semibold">ჩანაწერის სახელის შეცვლა</div>
    <button class="btn btn-sm btn-outline-light" type="button" (click)="selectedTitleItem = null">X</button>
  </div>

  <div class="mb-3">
    <label class="form-label text-white">სათაური ქართულად</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="selectedTitleItem.title"
      placeholder="სათაური ქართულად" />
  </div>

  <div class="mb-3">
    <label class="form-label text-white">Title in English</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="selectedTitleItem.title_en"
      placeholder="Title in English" />
  </div>

  <div class="d-flex justify-content-end gap-2">
    <button class="btn btn-outline-light" type="button" (click)="selectedTitleItem = null">გაუქმება</button>
    <button class="btn btn-primary" type="button" (click)="saveRecordingTitle()">შენახვა</button>
  </div>
</div>